import { render, staticRenderFns } from "./ProfessionalsSection.vue?vue&type=template&id=2d329a97"
import script from "./ProfessionalsSection.vue?vue&type=script&lang=js"
export * from "./ProfessionalsSection.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalsSection.vue?vue&type=style&index=0&id=2d329a97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports